import React from "react"
import styled from "styled-components"

import { StaticQuery, graphql } from "gatsby"

import LogoSVG from '../images/svg/ouroboros-logo.svg'
import IohkLogoSVG from '../images/svg/iohk-logo.svg'
import FBLogoSVG from '../images/svg/fb.svg'
import TwitterLogoSVG from '../images/svg/twitter.svg'
import YTLogoSVG from '../images/svg/yt.svg'


const Footer = styled.footer`
  position:relative;
  z-index:1;
  bottom:0;
  a {
    color: #ffffff;
  }
  .flexWrap{
    width:100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  .logos {
    display:flex;
    align-items:center;
    width:70%;
    * {
      display:inline-block;
    }
    .breakChar {
      margin:0 1rem;
      @media(max-width:767px) {
        display:none;
      }
    }
    h4, h6 {
      color:white;
      margin:0 1rem 0 0;
      font-weight:normal;
      text-transform: uppercase;
    }
    svg {
      max-width:140px;
      @media(max-width:767px) {
        display:none;
      }
    }
  }
  .social {
    padding-left: 20%;
    @media(max-width:767px) {
      padding-left: 5%;
    }
    width:30%;
    align-self: flex-end;
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 5rem;
    a {
      display:block;
    }
  }
  hr {
    margin-bottom:1rem;
    background-color: #ffffff;
    opacity:0.7;
  }
  .lowerFooter {
    font-size:80%;
    opacity:0.7;
  }
  .spaceBetween {
    justify-content: space-between;
  }
  @media(max-width:767px) {
    h6, div.footerLeft, div.footerRight {
      font-size:9px;
    }
  }
`

const FooterComponent = () => (
  <StaticQuery
    query={graphql`
    query {
      site {
        siteMetadata {
          title
        }
      }
    }
    `}
    render={data => (
      <Footer>
        <div className="flexWrap">
          <div className="logos">
            <LogoSVG/>
            <span className='breakChar'>|</span>
            <h6>
              IOHK - Supported Project
            </h6>
            <IohkLogoSVG/>
          </div>
          <div className="social">
            <a href="https://www.facebook.com/iohk.io/" target='_blank' rel="noopener noreferrer">
              <FBLogoSVG/>
            </a>
            <a href="https://twitter.com/inputoutputhk" target='_blank' rel="noopener noreferrer">
              <TwitterLogoSVG/>
            </a>
            <a href="https://www.youtube.com/channel/UCBJ0p9aCW-W82TwNM-z3V2w" target='_blank' rel="noopener noreferrer">
              <YTLogoSVG/>
            </a>
          </div>
        </div>
        
        <hr/>
        
        <div className="flexWrap spaceBetween lowerFooter">
          <div className="footerLeft">
            © {new Date().getFullYear()} Creative Commons.
          </div>
          <div className="footerRight">
            IOHK | <a href='https://static.iohk.io/docs/data-protection/iohk-data-protection-gdpr-policy.pdf' target='_blank' rel="noopener noreferrer">Data Protection</a>
          </div>
        </div>
      </Footer>
    )}
  />
)
export default FooterComponent
